// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BeU1","controls":"styles_controls__2xw4n","charLimit":"styles_charLimit__3dOZI","input":"styles_input__3NjQO","send":"styles_send__bWiQ_"};